export function calculation (state,val){
	// console.log(state,val)
	if(state){
		if(typeof val === 'object'&&val.length > 0){
			return ''
		}else if(typeof val === 'string'&&val){
			return ''
		}else if(typeof val === 'number'&&val>=0){
			return ''
		}else if(typeof val === 'boolean'&&val){
			return ''
		} else{
			return 'warp_red'
		}
	}
}